import { atom } from "jotai"
import { Caption, TopBanner } from "~/types"

export const aHasPlayed = atom(false)
export const aWatchedSeconds = atom(0)

export const aIsPlaying = atom(false)
export const aProgress = atom(0)
export const aDuration = atom(100)
export const aIsMobileMenuOpen = atom(false)
export const aIsMuted = atom(false)
export const aIsVolumeSliderVisible = atom(false)
export const aVolume = atom(1)

export const aIsCaptionsOpen = atom(false)
export const aCaptions = atom<Caption[]>([])
export const aCurrentCaption = atom<Caption | null>(null)

export const aIsQualityOpen = atom(false)
export const aVideoQuality = atom(-1)
export const aCurrentVideoQuality = atom(-1)
export const aVideoQualityLevelHeights = atom<number[]>([])

export const aIsSpeedOpen = atom(false)
export const aPlaybackSpeed = atom(1)

export const aIsPipMode = atom(false)
export const aIsFullscreen = atom(false)

// Top Banners
export const aTopBanners = atom<TopBanner[]>([])
export const aCurrentBanner = atom<TopBanner | null>((get) => {
  const topBanners = get(aTopBanners)
  const progress = get(aProgress)
  return (
    topBanners.find((banner) => {
      return (
        progress >= banner.start_seconds &&
        progress <= banner.start_seconds + banner.display_seconds
      )
    }) || null
  )
})
export const aBannerVisible = atom<boolean>((get) => {
  const currentBanner = get(aCurrentBanner)
  const progress = get(aProgress)
  return (
    !!currentBanner &&
    progress < currentBanner.start_seconds + currentBanner.display_seconds - 1
  )
})
